<div class="list-editions">
    <div class="edition-flappy" id="edition-flappy">
        <div class="edition-flappy-content">
            <h4>Edition I</h4>
            <div class="container">
                <p>Du 1er au 31 décembre 2020, le Play For Good Challenge proposait une expérience gaming-caritative
                    avec le jeu Flappy Bird.</p>
                <p>Grâce à la troupe des drôles d’oiseaux, 1 139 € ont été récoltés pour nos trois associations
                    partenaires Habitat & Humanisme, Le Foyer Notre Dame des Sans Abris et Entourage ! </p>
            </div>
            <button class="btn btn-light">En savoir plus</button>
        </div>
    </div>
    <div class="edition-riot" id="edition-riot">
        <div class="edition-riot-content">
            <h4>Edition II</h4>
            <div class="container">
                <p>L'Édition #2 revêtira un autre du visage du gaming-caritatif. Pour cette nouvelle page au chapitre,
                    l’eSport sera au centre du concept et vecteur de plus d’inclusion et de partage.</p>
                <p>L’événement récoltera des dons au profit d’une unique association: Handicap International.</p>
                <p>De plus, un cycle de conférences thématiques se tiendra pendant l’événement. </p>
            </div>
            <button class="btn btn-light" routerLink="edition-riot">En savoir plus</button>
        </div>
    </div>
</div>
